import { render, staticRenderFns } from "./ProductsLandedCosts.vue?vue&type=template&id=dc184254&scoped=true&"
import script from "./ProductsLandedCosts.vue?vue&type=script&lang=js&"
export * from "./ProductsLandedCosts.vue?vue&type=script&lang=js&"
import style0 from "./ProductsLandedCosts.vue?vue&type=style&index=0&id=dc184254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc184254",
  null
  
)

export default component.exports